import React from 'react';
import "../Figure.css"


function Figure8() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> </th>
              <th> Signal </th>
              <th> Concentration (mg/mL)</th>
              <th> Protein in 40 µL (mg)</th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> Sample 1 </th>
              <td> 0.429 </td>
              <td> 0.589 / 2 </td>
              <td> 11.8 </td>
            </tr> 
            <tr>
              <th> Sample 2 </th>
              <td> 0.4 </td>
              <td> 0.535 / 2 </td>
              <td> 10.6 </td>
            </tr>
            <tr>
              <th> Sample 3 </th>
              <td> 0.465 </td>
              <td> 0.806 / 2 </td>
              <td> 16.2 </td>
            </tr>
          </tbody>
        </table>
    </div>
  );
}

export default Figure8;